import * as React from 'react'
import { ActivityModel, Operations } from '@/modules/drivers/types/activities'
import { EventModel } from '@/app/models/newDelegation/eventModel'
import { PeriodSelection } from '@/app/models/periodSelection'

export type TimelineConfig = {
  flattenChart: boolean
  simpleMode: boolean
  editMode: boolean
  canEdit: boolean
  canGenerateAttestation: boolean
  disableTooltips: boolean
  readOnly: boolean
  printMode: boolean
  showRestLabels: boolean
  isRestsOnBaseModeOn: boolean

  minimalPaymentSuppressedPerSpan: boolean

  stackOverlappingMarkers: boolean

  dimOtherTripMarkers: boolean

  markInactiveVehicles: boolean

  translate: (text: string) => any
  onSelected?: (activity: ActivityModel | null) => void
  onEdit?: (activity: ActivityModel, operation: Operations | string) => void
  onAdd?: (activity: ActivityModel) => void
  onContextMenuChanged: (value: boolean, activity: any) => void
  onActivityContextMenu?: (activity: ActivityModel, x: number, y: number) => void
  onRestClick?: (activity: ActivityModel) => void
  onDaySelected?: (date: any) => void

  onViolationSelected?: () => void

  onPeriodSelectionsChanged?: (selections: Array<PeriodSelection>) => void

  editEvent?: (event: EventModel, shouldEdit: boolean) => void
  addEvent?: (event: EventModel) => void
  removeEvents?: (events: Array<EventModel>) => void
  hideDelegationMarkerPopups?: (event: EventModel) => void
  markNewEvent?: (event: EventModel) => void
}

const ConfigContext = React.createContext<TimelineConfig | null>(null)

export const ConfigProvider = ConfigContext.Provider

export const useConfig = (): TimelineConfig => {
  const config = React.useContext(ConfigContext)
  if (!config) {
    throw new Error('useConfig must be used inside <ConfigProvider>')
  }
  return config
}
